import { createFileRoute, useParams } from '@tanstack/react-router';
import { PostFormPage } from '@/components/admin/post-form/PostFormPage';

export const Route = createFileRoute('/admin/posts/$postId/edit')({
  component: EditPostRoute,
});

function EditPostRoute() {
  const { postId } = useParams({ from: '/admin/posts/$postId/edit' });
  return <PostFormPage postId={postId} />;
}
